//@flow
import React from 'react'
import AfricanCustomizedBoy from '../../../img/AfricanCustomizeBoy.svg?react'

export default function SurveySvgContainer() {
	return (
		<div className='SurveySvgContainer'>
			<AfricanCustomizedBoy />
		</div>
	)
}
